import { isEmpty } from 'lodash';
import IOrder from '~/interfaces/IOrder';
import getCurrencyFormatted from '~/utils/getCurrencyFormatted';
import { PAYMENT_METHODS } from '~/utils/getEnums';
import getAddressFormatted from './getAddressFormatted';

interface ISettingsCompany {
  print_description: string;
  waiter_name?: string;
  percentage_optional?: boolean;
  print_payment_value?: boolean;
  print_products?: boolean;
  parcial?: boolean;
}

export default function getPrintBluetooth(
  data: IOrder,
  {
    print_description,
    waiter_name,
    percentage_optional,
    print_payment_value,
    print_products,
    parcial,
  }: ISettingsCompany,
) {
  let products_txt = '';
  let totals_txt = '';
  let payment_txt = '';
  let address_txt = '';
  let header_txt = '';
  let waiter_txt = '';
  let cooking_orders = '';
  let totalValue = parseFloat(`${data.total}`);

  let subtotalValue = parseFloat(`${data.total}`);
  if (data.artisticCouvertTotal) {
    subtotalValue -= data.artisticCouvertTotal;
  }
  if (data.shippingCost) {
    subtotalValue -= data.shippingCost;
  }

  let orderType = 'DELIVERY';
  if (data.table?.uid) orderType = 'CONSUMO NO LOCAL';
  else if (isEmpty(data.address)) orderType = 'RETIRADA LOCAL';

  if (print_products) {
    cooking_orders += `Pedido: ${data.code}`;
    cooking_orders += `\n--------------------------------\n`;
    cooking_orders += data.table?.uid
      ? `MESA ${data.table?.name}`
      : `Cliente: ${data.name}`;
    cooking_orders += `\n--------------------------------`;
    cooking_orders += `\n${orderType}`;
    cooking_orders += `\n--------------------------------`;
    cooking_orders += `\nITENS DO PEDIDO\n`;
  }

  if (waiter_name) {
    waiter_txt += `ATENDIDO POR: ${waiter_name}`;
  }

  if (data.table?.uid) {
    header_txt = `MESA ${data.table?.name}`;
  } else {
    header_txt = `
    ${data.name}
    ${data.whatsapp}`;
  }

  data.products.forEach((item, index) => {
    const value = getCurrencyFormatted(parseFloat(item.value));
    const total = getCurrencyFormatted(parseFloat(item.value) * item.quantity);
    let complements_txt = '';

    if (item.complements) {
      item.complements.forEach(complement => {
        complements_txt += `${complement.quantity}x ${complement.item.name}\n`;
      });
    }

    if (index > 0) {
      products_txt += '\n\n';
    }

    products_txt += `${item.quantity}x ${item.name}\n`;

    if (print_description === '1' && !!item.description) {
      products_txt += `${item.description}\n`;
    }

    if (item.observations) {
      products_txt += `Obs: ${item.observations}\n`;
    }

    if (print_products) {
      cooking_orders += `-> ${item.quantity}x ${item.name}\n`;
      cooking_orders += complements_txt;

      if (item.observations) {
        cooking_orders += `Obs: ${item.observations}\n`;
      }
      cooking_orders += `\n`;
    }

    products_txt += complements_txt;
    products_txt += `${value} - ${total}`;
  });
  products_txt += '\n--------------------------------';

  totals_txt += 'TOTAIS\n';

  if (data.paymentMethod) {
    payment_txt += `PAGAMENTO              ${
      PAYMENT_METHODS[data.paymentMethod]
    }\n`;
  }

  if (data.orderPayments && data.orderPayments.length > 0) {
    payment_txt += 'PAGAMENTO';
    data.orderPayments.forEach(item => {
      if (item.value > 0) {
        payment_txt += `\n${
          PAYMENT_METHODS[item.payment_method_id] || 'INDEFINIDO'
        }                 ${item.value_formatted}`;
      }
    });
  }

  if (print_payment_value && data.thing) {
    const received = getCurrencyFormatted(parseFloat(data.thing));
    totals_txt += `RECEBER             ${received.padStart(13, ' ')}\n`;
  }

  if (data.thing) {
    const thing_value = getCurrencyFormatted(
      parseFloat(data.thing) - data.total,
    );
    totals_txt += `TROCO             ${thing_value.padStart(13, ' ')}\n`;
  }

  if (
    data.additionValue &&
    data.additionValue > 0 &&
    data.additionValue_formatted
  ) {
    totals_txt += `ACRÉSCIMO             ${data.additionValue_formatted.padStart(
      13,
      ' ',
    )}\n`;
  }

  totals_txt += `SUB-TOTAL         ${
    data.subtotal_formatted ? data.subtotal_formatted.padStart(13, ' ') : ''
  }\n`;

  if (data.artisticCouvertTotal && data.artisticCouvertTotal > 0) {
    totals_txt += `COUVERT         ${
      data.artisticCouvertTotal
        ? getCurrencyFormatted(data.artisticCouvertTotal)
        : ''
    }\n`;
  }

  if (data.shippingCost > 0) {
    totals_txt += `ENTREGA           ${
      data.shippingCost_formatted
        ? data.shippingCost_formatted?.padStart(13, ' ')
        : ''
    }\n`;
  }

  if (percentage_optional) {
    const percentgeValue = (subtotalValue * 10) / 100;
    totalValue += percentgeValue;
    const percentageTxt = getCurrencyFormatted(percentgeValue);
    totals_txt += `OPCIONAL          ${percentageTxt.padStart(13, ' ')}\n`;
  }

  const totalTxt = getCurrencyFormatted(totalValue);
  totals_txt += `TOTAL             ${totalTxt.padStart(13, ' ')}`;

  if (!isEmpty(data.address) && data.address.road) {
    address_txt += `--------------------------------\n`;
    address_txt += `ENTREGA\n`;
    address_txt += `${getAddressFormatted(data.address)}\n`;
  }

  if (!isEmpty(data.address) && !data.address.road) {
    address_txt += `--------------------------------\n`;
    address_txt += `ENTREGA\n`;
    address_txt += `${data.address}\n`;
  }

  if (isEmpty(data.address)) {
    address_txt += `--------------------------------\n`;
    address_txt += `ENTREGA\n`;
    address_txt += `RETIRADA LOCAL\n`;
  }

  let response = '';

  // se é pedido de mesa sem pagamento ele imprime apenas os produtos para cozinha
  if (!parcial) {
    if (data.table?.uid && !data.paymentMethod && !data.orderPayments) {
      response += `\n--------------------------------`;
      response += `\n${cooking_orders}`;
      return response;
    }
  }

  response += `\n\n${data.company_name.toLocaleUpperCase()}`;
  response += `\n--------------------------------`;
  response += `\n${data.created_at_formatted}`;
  response += `\n--------------------------------`;
  response += `\n${header_txt}`;
  response += `\n--------------------------------`;
  response += `\n       CUPOM NÃO FISCAL`;
  response += `\n--------------------------------`;
  response += `\n${products_txt}`;
  response += `\n${totals_txt}`;
  if (payment_txt) response += `\n\n${payment_txt}`;
  if (!data.table?.uid) response += `\n${address_txt}`;
  if (waiter_txt) response += `\n${waiter_txt}`;
  response += `\n--------------------------------`;
  response += `\nPEDIDO: ${data.code}`;
  response += `\n--------------------------------`;
  response += `\n          Tecnologia`;
  response += `\n    www.tem-pedido.web.app`;

  if (data.table?.uid && parcial) {
    return response;
  }

  if (print_products && ['DELIVERY', 'RETIRADA LOCAL'].includes(orderType)) {
    response += `\n\n\n`;
    response += `\n--------------------------------`;
    response += `\n${cooking_orders}`;
  }

  return response;
}
